<template>
    <v-dialog v-model="addFactoryDialog" @keydown.esc="addFactoryDialog = false" persistent max-width="600px" retain-focus>
        <template v-slot:activator="{ on, addFactoryAttrs }">
            <v-btn :color="buttonColor" class="mr-5" dark v-bind="addFactoryAttrs" v-on="on">
                <span v-if="buttonText" class="mr-2">{{ buttonText }}</span>
                <v-icon>mdi-account-plus</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">공장 등록</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" class="mb-n8">
                            <v-select
                                    :items="factoryGroupList"
                                    label="분류 *"
                                    item-value="text"
                                    v-model="factoryAttrs.factoryGroup"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" class="mb-n8">
                            <v-text-field label="거래처명 *" hint="거래처명을 입력하세요." v-model="factoryAttrs.factoryName" ref="factoryName" @focus="$event.target.select()" @focusout="checkDuplicateName" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="연락처 *" hint="연락처를 입력하세요." v-model="factoryAttrs.factoryPhone" required></v-text-field>
                        </v-col>
                        <v-textarea
                                class="px-3 mb-n8"
                                outlined
                                label="비 고"
                                v-model="factoryAttrs.factoryComment"
                        ></v-textarea>
                    </v-row>
                </v-container>
                <small>* 항목은 필수입니다.</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="saveFactory">저장</v-btn>
                <v-btn color="blue darken-1" text @click="addFactoryDialog = false">닫기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'AddFactoryButton',
    props: {
      buttonText: {},
      buttonColor: {}
    },
    data: function() {
        return {
            addFactoryDialog: false,
            bypass: false,
            prevKeyword: '',
            factoryAttrs: {
                factoryName: '',
                factoryPhone: '',
                factoryGroup: '',
                factoryComment: ''
            },
            factoryGroupList: this.$store.getters.getFactoryGroupList
        }
    },

    methods: {
        async checkDuplicateName() {

            if(this.prevKeyword != '' && this.prevKeyword != this.factoryAttrs.factoryName){
                this.bypass = false
            }

            if(this.bypass != true && this.factoryAttrs.factoryName.length > 0) {

                const result = await this.$store.dispatch(
                    'checkDuplicateName',
                    {
                        type: 'general',
                        name: this.factoryAttrs.factoryName,
                        bypass: this.bypass
                    }
                )

                if(result == '0000'){
                    this.bypass = true
                    this.prevKeyword = this.factoryAttrs.factoryName
                    this.$refs.factoryName.focus()
                }

            }

        },
        async saveFactory() {

            const result = await this.$store.dispatch(
                'saveFactory',
                this.factoryAttrs
            )

            if(result == '0000'){
                this.addFactoryDialog = false,
                this.factoryAttrs.factoryName = '',
                this.factoryAttrs.factoryPhone = '',
                this.factoryAttrs.factoryGroup = ''
                this.bypass = false
                if(this.buttonText){
                    location.reload()
                }
            }

        }
    }
}
</script>